const initialState = {
  user: null,
  polls: null,
  householdAccountIds: {
    // [householdId]: [ ...householdAccountIds ]
  },
  accounts: {
    // [accountId]: { ...account }
  },
  householdConnectionsIds: {
    // [householdId]: [ ...householdConnectionsIds ]
  },
  connections: {
    // [connections]: { ...connections }
  },
  householdConnectionLinksIds: {
    // [householdId]: [ ...householdConnectionLinksIds ]
  },
  connectionLinks: {
    // [connectionLinksId]: { ...connectionLinks }
  },
  privileges: {
    // [groupId]: {
    //  [privilege]: true / false
    //  }
  },
  subscriptions: {
    // [groupId]: {}
  },
  householdBenefitIds: {
    // [householdId]: [ ...householdBenefitIds ]
  },
  benefits: {
    // [benefitId]: { ...benefit }
  },
  householdEmployerIds: {
    // [householdId]: [ ...householdEmployerIds ]
  },
  employers: {
    // [employerId]: { ...employer }
  },
  households: {
    // [householdId]: [ ...household ]
  },
  householdIds: {
    // [userGroupId]: [ ...householdIds ]
  },
  incomeBreakdowns: {
    // [householdId]: [ ...householdIncomeIds ]
  },
  spendingBreakdowns: {
    // [householdId]: [ ...householdIncomeIds ]
  },
  householdIncomeIds: {
    // [householdId]: [ ...householdIncomeIds ]
  },
  incomes: {
    // [incomeId]: { ...income }
  },
  householdPersonIds: {
    // [householdId]: [ ...householdPersonIds ]
  },
  people: {
    // [personId]: { ...person }
  },
  householdPropertyIds: {
    // [householdId]: [ ...propertyIds ]
  },
  properties: {
    // [propertyId]: { ...property }
  },
  householdScenarioIds: {
    // [householdId]: [ ...scenarioIds ]
  },
  scenarios: {
    // [scenarioId]: { ...scenario }
  },
  userState: {
    // [key]: value
  },
  householdState: {
    // [householdId]: {
    //   currentLocation: "/organize/accounts+property",
    //   currentScenario: scenarioId,
    //   currentProposal: null,
    // }
  },
  scenarioGoalIds: {
    // [scenarioId]: [ ...scenarioGoalIds ]
  },
  goals: {
    // [goalId]: { ...goal }
  },
  scenarioProposalIds: {
    // [scenarioId]: [ ...scenarioProposalIds ]
  },
  proposals: {
    // [proposalId]: { ...proposal }
  },
  proposalStatuses: {
    // [proposalId]: { ...proposalStatus }
  },
  methodology: null,
  agreements: null,
  agreementTexts: {},
  termsAndConditions: null,
  invite: {},
  recovery: { id: null },
  scenarioProposalStatus: {
    // [scenarioId]: { ...proposalStatus }
  },
  faqs: {},
  allMinicourses: null,
  minicourses: {},
  latestProposalState: {
    // [scenarioId]: { ...proposalStatus }
  },
  householdOffers: {},
  interviews: {},
  newAgreements: [],
  nonExplicitAgreements: [],
  contextuals: {}
}

export default initialState
